if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();

      document.body.style.overflow = "scroll";
      document.body.style.padding = "0";
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay-spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          removeElementsByScreenSize(this.modalContent);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          this.stubMediaGallery();
          this.compactModalContent();
          super.show(opener);
          
          // Add smooth animation here
          this.modalContent.style.opacity = '0';
          this.modalContent.style.transform = 'scale(0.8)';
          this.modalContent.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
          
          setTimeout(() => {
            this.modalContent.style.opacity = '1';
            this.modalContent.style.transform = 'scale(1)';
          }, 0);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay-spinner').classList.add('hidden');
        });

        document.body.style.overflow = "hidden";
        document.body.style.padding = "0 4px 0 0";
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Skrypty zewnętrzne (np. media-gallery.js) są już załadowane i wykonane na stronie -
      // ponowne ich wykonanie rzuca "Identifier ... has already been declared" (klasy/consty
      // zadeklarowane na top-levelu nie da się zadeklarować drugi raz w tym samym scope).
      const loadedScriptSrcs = new Set(
        Array.from(document.scripts)
          .map(script => script.src)
          .filter(Boolean)
      );

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));

        if (newScriptTag.src && loadedScriptSrcs.has(newScriptTag.src)) {
          oldScriptTag.remove();
          return;
        }

        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    stubMediaGallery() {
      // <media-gallery> bywa nieobecny w skryptach doładowanych razem z sekcją produktu
      // (custom element nigdy się nie rejestruje), przez co VariantRadios.updateMedia()
      // wywala się na mediaGallery.setActiveMedia(...) i przerywa cały dalszy update
      // (cena, dostępność, przycisk "Dodaj do koszyka" zostaje trwale zablokowany).
      // W kompaktowym podglądzie pokazujemy jedno statyczne zdjęcie, więc przełączanie
      // multimediów i tak nie jest potrzebne - bezpieczna, pusta zaślepka.
      this.modalContent.querySelectorAll('[id^="MediaGallery-"]').forEach((el) => {
        if (typeof el.setActiveMedia !== 'function') {
          el.setActiveMedia = function () {};
        }
      });
    }

    compactModalContent() {
      const root = this.modalContent;
      // Ustawiane na true, jeśli wariant produktu to de facto rozmiar opakowania
      // (np. "Ilość: 1szt/6szt/12szt") - wtedy licznik "ile sztuk do koszyka" obok
      // jest zbędnym powtórzeniem tego samego wyboru i trzeba go całkiem usunąć,
      // a nie tylko inaczej podpisać.
      let hasPackSizeOption = false;

      // Gwiazdki (Judge.me) obok ceny
      const reviewsWidget = root.querySelector('.jdgm-widget, .jdgm-prev-badge');
      const priceEl = root.querySelector('.price');
      if (reviewsWidget && priceEl) {
        const reviewsRow = reviewsWidget.closest('.block');
        const priceRow = priceEl.closest('.block');
        if (reviewsRow && priceRow && reviewsRow !== priceRow) {
          // Uwaga: zmiana wariantu podmienia innerHTML kontenera ceny (#price-...),
          // więc nie wolno wstawiać gwiazdek DO ŚRODKA niego - tylko owinąć go razem
          // z gwiazdkami w nowy wrapper, żeby sam kontener ceny został nietknięty.
          const priceInner = priceRow.querySelector('.section-price-margin') || priceRow.firstElementChild;
          const reviewsContent = reviewsRow.firstElementChild;
          if (priceInner && reviewsContent) {
            const wrapper = document.createElement('div');
            wrapper.className = 'quick-add-price-row';
            priceInner.parentNode.insertBefore(wrapper, priceInner);
            wrapper.appendChild(priceInner);
            wrapper.appendChild(reviewsContent);
          }
          reviewsRow.remove();
        }
      }

      // Warianty (waga, mielenie) jako selecty obok siebie
      const variantRadios = root.querySelector('variant-radios');
      if (variantRadios) {
        const fieldsets = [...variantRadios.querySelectorAll('fieldset.product-form-input')];
        if (fieldsets.length) {
          const row = document.createElement('div');
          row.className = 'quick-add-select-row';
          const selectPairs = [];

          fieldsets.forEach((fieldset) => {
            const legend = fieldset.querySelector('legend');
            const optionName = legend && legend.childNodes.length
              ? legend.childNodes[0].textContent.trim().replace(/:$/, '')
              : '';
            const inputs = [...fieldset.querySelectorAll('input[type="radio"]')];
            if (!inputs.length) return;

            // Niektóre produkty nazywają wariant (np. rozmiar opakowania: 1szt/6szt/12szt)
            // dokładnie "Ilość" - to samo słowo co licznik sztuk w koszyku obok. Żeby nie
            // wyglądało na zdublowane pole, w tym jednym przypadku pokazujemy "Opakowanie".
            const isPackSizeOption = optionName.toLowerCase() === 'ilość';
            if (isPackSizeOption) hasPackSizeOption = true;
            const displayName = isPackSizeOption ? 'Opakowanie' : optionName;

            // Uwaga: NIE dawać klasy "product-form-input" (jej już używają ukryte
            // fieldsety) - VariantRadios.updateVariantStatuses() liczy dostępność
            // po kolejności elementów .product-form-input, więc zduplikowanie tej
            // klasy rozjeżdża indeksy i trwale blokuje przycisk "Dodaj do koszyka".
            const wrap = document.createElement('div');
            wrap.className = 'quick-add-select-wrap';

            const label = document.createElement('label');
            label.className = 'form-label';
            label.textContent = displayName;

            const selectWrap = document.createElement('div');
            selectWrap.className = 'select';

            const select = document.createElement('select');
            select.className = 'select__select';

            inputs.forEach((input) => {
              const opt = document.createElement('option');
              opt.value = input.value;
              opt.textContent = input.value;
              if (input.checked) opt.selected = true;
              select.appendChild(opt);
            });

            select.addEventListener('change', (event) => {
              // Nie pozwól, żeby własny "change" selecta (który też bąbelkuje) wywołał
              // VariantRadios.onVariantChange() DRUGI raz - liczy się tylko change
              // rozesłany z prawdziwego (ukrytego) radia niżej.
              event.stopPropagation();
              const match = inputs.find((inp) => inp.value === select.value);
              if (match) {
                match.checked = true;
                match.dispatchEvent(new Event('change', { bubbles: true }));
              }
              syncSelectAvailability();
            });

            selectWrap.appendChild(select);
            selectWrap.insertAdjacentHTML(
              'beforeend',
              '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>'
            );

            wrap.appendChild(label);
            wrap.appendChild(selectWrap);
            row.appendChild(wrap);
            selectPairs.push({ select, inputs });
          });

          // Po każdej zmianie warianty niedostępne w danej kombinacji muszą być
          // od razu disabled w selectach + podpisane "- Niedostępne", zamiast
          // cichego blokowania koszyka bez wyjaśnienia.
          function syncSelectAvailability() {
            selectPairs.forEach(({ select, inputs }) => {
              inputs.forEach((input, i) => {
                const opt = select.options[i];
                if (!opt) return;
                const unavailable = input.classList.contains('disabled');
                opt.disabled = unavailable;
                const strings = window.variantStrings || {};
                opt.textContent = unavailable && strings.unavailable_with_option
                  ? strings.unavailable_with_option.replace('[value]', input.value)
                  : input.value;
              });
            });
          }

          variantRadios.insertBefore(row, variantRadios.firstElementChild);
          syncSelectAvailability();
        }
      }

      // Ilość obok "Dodaj do koszyka"
      const quantityBlock = root.querySelector('.product-form-quantity');
      const buttonsRow = root.querySelector('.product-form__buttons');
      if (quantityBlock && buttonsRow) {
        if (hasPackSizeOption) {
          // Rozmiar opakowania ("Opakowanie: 1szt/6szt/12szt") już określa liczbę
          // sztuk - osobny stepper "ile sztuk do koszyka" byłby drugim polem
          // odpowiadającym za dokładnie to samo, więc usuwamy go z podglądu
          // (input zostaje w DOM z wartością 1, żeby formularz działał normalnie;
          // kto chce kupić więcej niż jedno opakowanie, użyje pełnej strony produktu).
          quantityBlock.style.display = 'none';
        } else {
          buttonsRow.insertBefore(quantityBlock, buttonsRow.firstElementChild);
          const quantityLabel = quantityBlock.querySelector('.quantity-label');
          if (quantityLabel && quantityLabel.firstChild) {
            quantityLabel.firstChild.textContent = 'Sztuk: ';
          }
        }
      }
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}